import React, { Fragment, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import SmartSubMenu from '../smart-submenu/smart-submenu'
import './smart-sidebar.scss'
import { Color, LuxIcon, useWindowResize } from '@lux/wardrobe-lib'
import {
    UserHelper,
    NotificationsApi,
    NotificationSourceModule,
    MenuItemsCodeEnum,
    EventsType,
    layoutActions,
} from '@Techedge/digitalportal-shared'
import { connect } from 'react-redux'
import { from, interval } from 'rxjs'
import { tap } from 'rxjs/operators'
import { menuItemsMock } from './menu-items'
import { useIntl } from 'react-intl'
import { SidebarServices } from '../../services/SidebarServices'

const SmartSidebar = (props: any) => {
    const intl = useIntl()

    const isMobile = useWindowResize()

    const BASE_URL: string = process.env.REACT_APP_BASE_URL_BE

    const navigate = useNavigate()
    const { portals, getActions, permissions } = props
    const [menuItems, setMenuItems] = useState(menuItemsMock)
    const [notificationsCount, setNotificationsCount] = useState(undefined)
    const [isMenuLoaded, setIsMenuLoaded] = useState<boolean>(false)
    const [menuToRender, setMenuToRender] = useState(menuItemsMock)
    const [isIntervalSetUp, setIsIntervalSetUp] = useState(false)
    const [grsdToken, setGrsdToken] = useState('')

    useEffect(() => {
        SidebarServices.GetGRSDToken().then((res) => {
            setGrsdToken(res.data.access_token)
        })
    }, [])

    useEffect(() => {
        if (
            !isIntervalSetUp &&
            !!UserHelper._shared().accessToken() &&
            !!portals
        ) {
            interval(300000)
                .pipe(
                    tap(() => {
                        let newMenuItems = [
                            ...UserHelper._shared().getPortalDetails(portals)
                                .applications,
                        ]
                        let notificationsMenu = newMenuItems.find(
                            (item) =>
                                item.code ===
                                MenuItemsCodeEnum.SMARTLY_NOTIFICATIONS_MENU_CODE
                        )
                        setBadge(newMenuItems, notificationsMenu)
                    })
                )
                .subscribe()
            if (!permissions) {
                getActions()
            }
            setIsIntervalSetUp(true)
        }
    }, [UserHelper._shared().accessToken(), isIntervalSetUp, portals])

    useEffect(() => {
        const handler = () => {
            if (menuItems && menuItems.length > 0) {
                let notificationsMenu = menuItems.find(
                    (item) =>
                        item.code ===
                        MenuItemsCodeEnum.SMARTLY_NOTIFICATIONS_MENU_CODE
                )
                setBadge(menuItems, notificationsMenu)
            }
        }
        window.addEventListener(EventsType.NOTIFICATION_READ, handler)
        return () => {
            window.removeEventListener(EventsType.NOTIFICATION_READ, handler)
        }
    }, [menuItems])

    useEffect(() => {
        if (!isMenuLoaded && !!portals && portals.length > 0) {
            initMenu()
        }
    }, [portals, isMenuLoaded, permissions])

    useEffect(() => {
        if (menuItems?.length > 4) {
            let tmpMenuItems = []
            if (isMobile) {
                let extraMenuItems = []
                for (let i = 0; i < menuItems.length; i++) {
                    let menuItem = menuItems[i]
                    if (menuItem.path !== '/menu') {
                        if (i < 4) {
                            tmpMenuItems.push(menuItem)
                        } else if (menuItem.code !== 'SMARTLY_MENU') {
                            extraMenuItems.push({
                                ...menuItem,
                                extraMenu: true,
                            })
                        }
                    } else {
                        tmpMenuItems.push({
                            ...menuItem,
                            children: [...extraMenuItems, ...menuItem.children],
                        })
                    }
                }
            } else {
                tmpMenuItems = [...menuItems]
            }

            tmpMenuItems?.find((item) => {
                if (item.code.includes('SMARTLY_MENU')) {
                    let subMenuItems = item.children

                    subMenuItems.find((subItem, index) => {
                        if (subItem?.code?.includes('OLD_STORE360')) {
                            let tmp = subMenuItems[subMenuItems.length - 1]
                            subMenuItems[subMenuItems.length - 1] =
                                subMenuItems[index]
                            subMenuItems[index] = tmp
                        }
                    })
                }
            })

            setMenuToRender(setActiveMenuItem(tmpMenuItems))
        }
    }, [isMobile, menuItems])

    const useReactPath = () => {
        const [path, setPath] = useState<string>(window.location.pathname)
        const listenToPopstate = () => {
            const winPath = window.location.pathname
            setPath(winPath)
        }
        useEffect(() => {
            window.addEventListener('popstate', listenToPopstate)
            return () => {
                window.removeEventListener('popstate', listenToPopstate)
            }
        }, [])
        return path
    }

    const path = useReactPath()

    useEffect(() => {
        if (path.includes('/aftersales')) {
            props.setShowFabButton(false)
        } else {
            props.setShowFabButton(true)
        }
    }, [path])

    const setBadge = (menu, notificationsMenu) => {
        const modules = [NotificationSourceModule.COMMUNICATION]
        if (props.user.phase2_enabled) {
            modules.push(NotificationSourceModule.PICTURE_MANAGMENT)
            modules.push(NotificationSourceModule.STORE_VISIT)
        }
        from(
            NotificationsApi.getNotificationsCount(
                {
                    source_module: modules,
                    is_new: true,
                },
                BASE_URL
            )
        )
            .pipe(
                tap((res: any) => {
                    setNotificationsCount(res.data.count)
                    notificationsMenu.badge = res.data.count
                    setMenuItems(setActiveMenuItem([...menu]))
                    setIsMenuLoaded(false)
                })
            )
            .subscribe()
    }

    const setMenu = (menu) => {
        let newMenuItems = menu
        let notificationsMenu = newMenuItems.find(
            (item) =>
                item.code === MenuItemsCodeEnum.SMARTLY_NOTIFICATIONS_MENU_CODE
        )

        if (!!notificationsMenu && isNaN(notificationsCount)) {
            setBadge(newMenuItems, notificationsMenu)
        } else {
            setIsMenuLoaded(false)
        }

        setMenuItems(setActiveMenuItem(menu))
    }

    const initMenu = () => {
        const portals = UserHelper._shared().permissions().portals
        const selectedPortal = UserHelper._shared().getPortalDetails(portals)
        if (selectedPortal?.code === 'SMRT' && selectedPortal.applications) {
            setIsMenuLoaded(true)
            const _apps = [...selectedPortal.applications]
            const path = window.location.pathname.split('/')
            const pathBase = path[1]
            const pathEnd = path[path.length - 1]
            const selectedApp = _apps.find((a) => a.path === `/${pathBase}`)
            if (selectedApp) {
                selectedApp.active = true
                selectedApp.showSubmenu = true
                const selectedSubItem = selectedApp.children?.find(
                    (c) => c.path === `/${pathEnd}`
                )
                if (selectedSubItem) {
                    selectedApp.selectedChild = selectedSubItem
                    selectedApp.showSubmenu = false
                }
            } else {
                if (!!_apps[0]) _apps[0].active = true
            }
            setMenu(_apps)
        } else {
            setMenuItems([])
        }
    }

    const menuItemSelectionHandler = (
        menuItem: any,
        openSubMenu: boolean,
        childCode?: string
    ) => {
        if (menuItem) {
            // commit SMA-1602
            props.resetBreadcrumb() // reset breadcrumb when menu item is clicked
            let updatedMenuItems = []
            let tmpMenuItems = [...menuToRender]
            for (let i = 0; i < tmpMenuItems.length; i++) {
                let tmpMenuItem: any = tmpMenuItems[i]
                tmpMenuItem.active = false
                if (tmpMenuItem.title === menuItem.title) {
                    tmpMenuItem.active = true
                    tmpMenuItem.showSubmenu = openSubMenu
                } else {
                    tmpMenuItem.showSubmenu = false
                }
                if (
                    childCode &&
                    tmpMenuItem.children &&
                    tmpMenuItem.children.find((c) => c.code === childCode)
                ) {
                    tmpMenuItem.selectedChild = tmpMenuItem.children.find(
                        (c) => c.code === childCode
                    )
                } else {
                    tmpMenuItem.selectedChild = ''
                }
                updatedMenuItems.push(tmpMenuItem)
            }
            setMenuToRender(updatedMenuItems)
        }
    }

    const setActiveMenuItem = (_menuItems: any[]) => {
        if (_menuItems?.length > 0) {
            let tmpMenuItems = []
            for (let i = 0; i < _menuItems.length; i++) {
                let tmpMenuItem: any = { ..._menuItems[i] }

                tmpMenuItem.active = false
                const parentPath = '/' + path.split('/')[1]

                if (parentPath === '/' && tmpMenuItem.path === '/home') {
                    tmpMenuItem.active = true
                } else if (parentPath !== '/menu') {
                    tmpMenuItem.showSubmenu = false
                    if (
                        // reports exception: path doesn't include /menu/ (why??)
                        (parentPath == '/reporting' ||
                            parentPath == '/aftersales') &&
                        tmpMenuItem.code == 'SMARTLY_MENU'
                    ) {
                        let tmpMenuItemChildren = tmpMenuItem.children
                        let newSelectedChild

                        if (parentPath == '/reporting') {
                            newSelectedChild = tmpMenuItemChildren?.find(
                                (c) => c.code == 'SMARTLY_REPORTS'
                            )
                        } else if (parentPath == '/aftersales') {
                            newSelectedChild = tmpMenuItemChildren?.find(
                                (c) => c.code == 'AFTERSALES'
                            )
                        }

                        tmpMenuItem.active = true
                        tmpMenuItem.selectedChild = newSelectedChild
                    } else {
                        if (tmpMenuItem.path === '/menu') {
                            if (
                                tmpMenuItem.children?.find(
                                    (item) =>
                                        parentPath === item.path &&
                                        item.extraMenu
                                )
                            ) {
                                tmpMenuItem.active = true
                            } else {
                                tmpMenuItem.active = false
                            }
                            tmpMenuItem.selectedChild = null
                        } else if (parentPath === tmpMenuItem.path) {
                            tmpMenuItem.active = true
                        }
                    }
                } else if (
                    parentPath == '/menu' &&
                    tmpMenuItem.path === '/menu'
                ) {
                    tmpMenuItem.active = true
                    if (!path.split('/')[2]) {
                        tmpMenuItem.showSubmenu = true
                        tmpMenuItem.selectedChild = null
                    } else if (tmpMenuItem?.children?.length > 0) {
                        tmpMenuItem.showSubmenu = false
                        let tmpMenuItemChildren = tmpMenuItem.children
                        let newSelectedChild = tmpMenuItem.selectedChild
                        for (let x = 0; x < tmpMenuItemChildren.length; x++) {
                            let tmpMenuItemChild = tmpMenuItemChildren[x]
                            if (tmpMenuItemChild.path === path) {
                                newSelectedChild = tmpMenuItemChild
                            }
                        }
                        tmpMenuItem.selectedChild = newSelectedChild
                    }
                }
                tmpMenuItems.push(tmpMenuItem)
            }

            return tmpMenuItems
        }
        return _menuItems
    }

    if (!props.showSidebar) return <Fragment></Fragment>

    return (
        <>
            <div id="smart-sidebar">
                <div className="sidebar-content">
                    {menuToRender &&
                        menuToRender.map((menuItem: any, i: number) => {
                            return (
                                <div
                                    key={i}
                                    style={
                                        !isMobile
                                            ? {
                                                  width: '100%',
                                                  backgroundColor:
                                                      'var(--lux-white)',
                                              }
                                            : {
                                                  width: '100%',
                                                  height: '100%',
                                              }
                                    }>
                                    <div
                                        onClick={() => {
                                            menuItemSelectionHandler(
                                                menuItem,
                                                true
                                            )
                                            navigate(`${menuItem.path}`)
                                        }}
                                        className={`menu-item ${menuItem.path}${
                                            menuItem?.active ? ' active' : ''
                                        }${
                                            menuItem.children
                                                ? ' has-children'
                                                : ''
                                        }${
                                            !isMobile && menuItem?.selectedChild
                                                ? ' selected-child'
                                                : ''
                                        }`}>
                                        <LuxIcon
                                            size={20}
                                            icon={menuItem.icon}
                                            color={
                                                menuItem?.active
                                                    ? Color.WHITE
                                                    : Color.BLACK
                                            }
                                        />
                                        {menuItem?.badge > 0 && (
                                            <div className="menu-item--badge"></div>
                                        )}
                                        <label>
                                            {intl.formatMessage({
                                                id: `sidebar.menuItem.code.${menuItem.code}`,
                                                defaultMessage: menuItem.title,
                                            })}
                                        </label>
                                        {!isMobile &&
                                            menuItem?.selectedChild && (
                                                <div className="triangle">
                                                    <div className="inner-triangle"></div>
                                                </div>
                                            )}
                                    </div>
                                    {!isMobile && menuItem?.selectedChild && (
                                        <div className="menu-item menu-item-selected-child">
                                            <LuxIcon
                                                size={20}
                                                color={Color.WARNING}
                                                icon={
                                                    menuItem?.selectedChild.icon
                                                }
                                            />
                                            <label>
                                                {intl.formatMessage({
                                                    id: `sidebar.menuItem.code.${menuItem.selectedChild.code}`,
                                                    defaultMessage:
                                                        menuItem.selectedChild
                                                            .title,
                                                })}
                                            </label>
                                        </div>
                                    )}
                                    {menuItem.children &&
                                        menuItem?.showSubmenu && (
                                            <SmartSubMenu
                                                permissions={permissions}
                                                basePath={menuItem.path}
                                                subMenuItems={menuItem.children}
                                                grsdToken={grsdToken}
                                                onChildClick={(code) =>
                                                    menuItemSelectionHandler(
                                                        menuItem,
                                                        false,
                                                        code
                                                    )
                                                }
                                            />
                                        )}
                                </div>
                            )
                        })}
                </div>
            </div>
        </>
    )
}

const mapStateToProps = (state: any) => ({
    showSidebar: state.layoutReducer.showSidebar,
    showFabButton: state.layoutReducer.showFabButton,
    portals: state.userReducer.permissions?.portals,
    permissions: state.permissionsReducer?.actions,
    user: state.userReducer.user,
})

const mapDispatchToProps = (dispatch: any) => ({
    setShowFabButton: (value: boolean) =>
        dispatch(layoutActions.setShowFabButton(value)),
    resetBreadcrumb: () => dispatch(layoutActions.resetBreadcrumb()),
})

export default connect(mapStateToProps, mapDispatchToProps)(SmartSidebar)
